export const translations = {
  de: {
    // Nav
    "nav.showroom": "Showroom",
    "nav.shop": "Shop",
    "nav.about": "Über mich",
    "nav.contact": "Kontakt",
    "nav.cart": "Warenkorb",
    "nav.login": "Anmelden",
    "nav.logout": "Abmelden",
    "nav.profile": "Profil",
    "nav.orders": "Bestellungen",
    "nav.wishlist": "Wunschliste",
    "nav.admin": "Admin",

    // Home / Showroom
    "home.hero.subtitle": "3D-gedruckte Kunst",
    "home.hero.title": "Wo Form\nZukunft wird.",
    "home.hero.desc": "Handgefertigte 3D-Druckobjekte – Skulpturen, Architekturmodelle und geometrische Formen, die Räume in Ausstellungen verwandeln.",
    "home.hero.cta": "Showroom betreten",
    "home.hero.shop": "Zum Shop",
    "home.showroom.title": "Ausgewählte Werke",
    "home.showroom.subtitle": "Jedes Objekt ist ein Unikat",
    "home.load_more": "Mehr laden",
    "home.loading": "Wird geladen...",
    "home.no_more": "Alle Werke geladen",
    "home.view_detail": "Details ansehen",
    "home.categories.all": "Alle",
    "home.categories.sculpture": "Skulpturen",
    "home.categories.geometric": "Geometrisch",
    "home.categories.architecture": "Architektur",
    "home.categories.functional": "Funktional",
    "home.categories.general": "Allgemein",

    // Product
    "product.add_to_cart": "In den Warenkorb",
    "product.add_to_wishlist": "Zur Wunschliste",
    "product.remove_wishlist": "Von Wunschliste entfernen",
    "product.in_stock": "Verfügbar",
    "product.out_of_stock": "Nicht verfügbar",
    "product.material": "Material",
    "product.dimensions": "Maße",
    "product.category": "Kategorie",
    "product.price": "Preis",
    "product.quantity": "Menge",
    "product.buy_now": "Jetzt kaufen",
    "product.back": "Zurück",
    "product.stock_count": "Stück verfügbar",
    "product.featured": "Highlight",
    "product.new": "Neu",
    "product.not_found": "Produkt nicht gefunden",

    // Shop
    "shop.title": "Shop",
    "shop.subtitle": "Alle Werke im Überblick",
    "shop.filter": "Filter",
    "shop.sort": "Sortieren",
    "shop.no_products": "Keine Produkte gefunden",
    "shop.sort.price_asc": "Preis: Aufsteigend",
    "shop.sort.price_desc": "Preis: Absteigend",
    "shop.sort.newest": "Neueste zuerst",
    "shop.sort.featured": "Highlights zuerst",

    // Cart
    "cart.title": "Warenkorb",
    "cart.empty": "Dein Warenkorb ist leer",
    "cart.empty.desc": "Entdecke unsere einzigartigen 3D-Druckobjekte",
    "cart.total": "Gesamt",
    "cart.checkout": "Zur Kasse",
    "cart.continue": "Weiter shoppen",
    "cart.remove": "Entfernen",
    "cart.subtotal": "Zwischensumme",
    "cart.shipping": "Versand",
    "cart.free_shipping": "Kostenlos",
    "cart.items": "Artikel",

    // Checkout
    "checkout.title": "Kasse",
    "checkout.shipping": "Lieferadresse",
    "checkout.payment": "Zahlung",
    "checkout.summary": "Bestellübersicht",
    "checkout.first_name": "Vorname",
    "checkout.last_name": "Nachname",
    "checkout.email": "E-Mail",
    "checkout.phone": "Telefon",
    "checkout.address": "Straße & Hausnummer",
    "checkout.city": "Stadt",
    "checkout.zip": "PLZ",
    "checkout.country": "Land",
    "checkout.notes": "Anmerkungen",
    "checkout.place_order": "Bestellung aufgeben",
    "checkout.pay_paypal": "Mit PayPal bezahlen",
    "checkout.success": "Bestellung aufgegeben!",
    "checkout.success.desc": "Deine Bestellung wird bearbeitet.",
    "checkout.required": "Pflichtfeld",

    // Auth
    "auth.login": "Anmelden",
    "auth.register": "Registrieren",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.name": "Name",
    "auth.login.submit": "Anmelden",
    "auth.register.submit": "Konto erstellen",
    "auth.have_account": "Bereits ein Konto?",
    "auth.no_account": "Noch kein Konto?",
    "auth.welcome": "Willkommen zurück",
    "auth.create_account": "Konto erstellen",
    "auth.forgot_password": "Passwort vergessen?",
    "auth.error": "Anmeldung fehlgeschlagen",

    // Profile
    "profile.title": "Mein Profil",
    "profile.orders": "Meine Bestellungen",
    "profile.wishlist": "Wunschliste",
    "profile.settings": "Einstellungen",
    "profile.no_orders": "Keine Bestellungen vorhanden",
    "profile.order_id": "Bestellnummer",
    "profile.order_date": "Datum",
    "profile.order_total": "Gesamt",
    "profile.order_status": "Status",
    "profile.status.pending": "Ausstehend",
    "profile.status.processing": "In Bearbeitung",
    "profile.status.shipped": "Versendet",
    "profile.status.delivered": "Zugestellt",
    "profile.status.cancelled": "Storniert",

    // About
    "about.title": "Über Lirk Print",
    "about.subtitle": "Die Geschichte dahinter",
    "about.story.title": "Meine Geschichte",
    "about.process.title": "Der Prozess",
    "about.process.desc": "Von der digitalen Idee zum physischen Objekt – jedes Stück durchläuft einen sorgfältigen Entstehungsprozess.",
    "about.philosophy.title": "Meine Philosophie",
    "about.philosophy.desc": "Ich glaube, dass 3D-Druck die Grenze zwischen digitaler und physischer Welt aufhebt. Jedes Objekt ist eine Brücke zwischen Konzept und Realität.",

    // Contact
    "contact.title": "Kontakt",
    "contact.subtitle": "Lass uns sprechen",
    "contact.name": "Name",
    "contact.email": "E-Mail",
    "contact.subject": "Betreff",
    "contact.message": "Nachricht",
    "contact.send": "Nachricht senden",
    "contact.success": "Nachricht erfolgreich gesendet!",
    "contact.error": "Fehler beim Senden. Bitte versuche es erneut.",
    "contact.custom_order": "Sonderanfertigung anfragen",
    "contact.subjects.general": "Allgemeine Anfrage",
    "contact.subjects.order": "Bestellanfrage",
    "contact.subjects.custom": "Sonderanfertigung",
    "contact.subjects.collab": "Zusammenarbeit",

    // Admin
    "admin.title": "Admin Dashboard",
    "admin.products": "Produkte",
    "admin.orders": "Bestellungen",
    "admin.messages": "Nachrichten",
    "admin.stats": "Statistiken",
    "admin.add_product": "Produkt hinzufügen",
    "admin.edit_product": "Produkt bearbeiten",
    "admin.delete_product": "Produkt löschen",
    "admin.save": "Speichern",
    "admin.cancel": "Abbrechen",
    "admin.confirm_delete": "Wirklich löschen?",
    "admin.seed": "Demo-Produkte erstellen",
    "admin.total_products": "Produkte",
    "admin.total_orders": "Bestellungen",
    "admin.total_revenue": "Gesamtumsatz",
    "admin.total_users": "Kunden",

    // Footer
    "footer.tagline": "Premium 3D-Druckobjekte",
    "footer.rights": "Alle Rechte vorbehalten",
    "footer.links": "Links",
    "footer.connect": "Kontakt",
  },
  en: {
    // Nav
    "nav.showroom": "Showroom",
    "nav.shop": "Shop",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.cart": "Cart",
    "nav.login": "Sign In",
    "nav.logout": "Sign Out",
    "nav.profile": "Profile",
    "nav.orders": "Orders",
    "nav.wishlist": "Wishlist",
    "nav.admin": "Admin",

    // Home / Showroom
    "home.hero.subtitle": "3D Printed Art",
    "home.hero.title": "Where Form\nBecomes Future.",
    "home.hero.desc": "Handcrafted 3D printed objects – sculptures, architectural models and geometric forms that transform spaces into exhibitions.",
    "home.hero.cta": "Enter Showroom",
    "home.hero.shop": "Visit Shop",
    "home.showroom.title": "Selected Works",
    "home.showroom.subtitle": "Every object is unique",
    "home.load_more": "Load more",
    "home.loading": "Loading...",
    "home.no_more": "All works loaded",
    "home.view_detail": "View details",
    "home.categories.all": "All",
    "home.categories.sculpture": "Sculptures",
    "home.categories.geometric": "Geometric",
    "home.categories.architecture": "Architecture",
    "home.categories.functional": "Functional",
    "home.categories.general": "General",

    // Product
    "product.add_to_cart": "Add to Cart",
    "product.add_to_wishlist": "Add to Wishlist",
    "product.remove_wishlist": "Remove from Wishlist",
    "product.in_stock": "In Stock",
    "product.out_of_stock": "Out of Stock",
    "product.material": "Material",
    "product.dimensions": "Dimensions",
    "product.category": "Category",
    "product.price": "Price",
    "product.quantity": "Quantity",
    "product.buy_now": "Buy Now",
    "product.back": "Back",
    "product.stock_count": "pieces available",
    "product.featured": "Featured",
    "product.new": "New",
    "product.not_found": "Product not found",

    // Shop
    "shop.title": "Shop",
    "shop.subtitle": "All works at a glance",
    "shop.filter": "Filter",
    "shop.sort": "Sort",
    "shop.no_products": "No products found",
    "shop.sort.price_asc": "Price: Ascending",
    "shop.sort.price_desc": "Price: Descending",
    "shop.sort.newest": "Newest first",
    "shop.sort.featured": "Featured first",

    // Cart
    "cart.title": "Cart",
    "cart.empty": "Your cart is empty",
    "cart.empty.desc": "Discover our unique 3D printed objects",
    "cart.total": "Total",
    "cart.checkout": "Checkout",
    "cart.continue": "Continue shopping",
    "cart.remove": "Remove",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Shipping",
    "cart.free_shipping": "Free",
    "cart.items": "items",

    // Checkout
    "checkout.title": "Checkout",
    "checkout.shipping": "Shipping Address",
    "checkout.payment": "Payment",
    "checkout.summary": "Order Summary",
    "checkout.first_name": "First Name",
    "checkout.last_name": "Last Name",
    "checkout.email": "Email",
    "checkout.phone": "Phone",
    "checkout.address": "Street & Number",
    "checkout.city": "City",
    "checkout.zip": "ZIP Code",
    "checkout.country": "Country",
    "checkout.notes": "Notes",
    "checkout.place_order": "Place Order",
    "checkout.pay_paypal": "Pay with PayPal",
    "checkout.success": "Order placed!",
    "checkout.success.desc": "Your order is being processed.",
    "checkout.required": "Required",

    // Auth
    "auth.login": "Sign In",
    "auth.register": "Register",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Name",
    "auth.login.submit": "Sign In",
    "auth.register.submit": "Create Account",
    "auth.have_account": "Already have an account?",
    "auth.no_account": "Don't have an account?",
    "auth.welcome": "Welcome back",
    "auth.create_account": "Create account",
    "auth.forgot_password": "Forgot password?",
    "auth.error": "Login failed",

    // Profile
    "profile.title": "My Profile",
    "profile.orders": "My Orders",
    "profile.wishlist": "Wishlist",
    "profile.settings": "Settings",
    "profile.no_orders": "No orders yet",
    "profile.order_id": "Order ID",
    "profile.order_date": "Date",
    "profile.order_total": "Total",
    "profile.order_status": "Status",
    "profile.status.pending": "Pending",
    "profile.status.processing": "Processing",
    "profile.status.shipped": "Shipped",
    "profile.status.delivered": "Delivered",
    "profile.status.cancelled": "Cancelled",

    // About
    "about.title": "About Lirk Print",
    "about.subtitle": "The story behind it",
    "about.story.title": "My Story",
    "about.process.title": "The Process",
    "about.process.desc": "From digital idea to physical object – each piece goes through a careful creation process.",
    "about.philosophy.title": "My Philosophy",
    "about.philosophy.desc": "I believe 3D printing dissolves the boundary between digital and physical worlds. Every object is a bridge between concept and reality.",

    // Contact
    "contact.title": "Contact",
    "contact.subtitle": "Let's talk",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.subject": "Subject",
    "contact.message": "Message",
    "contact.send": "Send Message",
    "contact.success": "Message sent successfully!",
    "contact.error": "Failed to send. Please try again.",
    "contact.custom_order": "Request custom order",
    "contact.subjects.general": "General Inquiry",
    "contact.subjects.order": "Order Inquiry",
    "contact.subjects.custom": "Custom Order",
    "contact.subjects.collab": "Collaboration",

    // Admin
    "admin.title": "Admin Dashboard",
    "admin.products": "Products",
    "admin.orders": "Orders",
    "admin.messages": "Messages",
    "admin.stats": "Statistics",
    "admin.add_product": "Add Product",
    "admin.edit_product": "Edit Product",
    "admin.delete_product": "Delete Product",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.confirm_delete": "Really delete?",
    "admin.seed": "Create Demo Products",
    "admin.total_products": "Products",
    "admin.total_orders": "Orders",
    "admin.total_revenue": "Total Revenue",
    "admin.total_users": "Customers",

    // Footer
    "footer.tagline": "Premium 3D Printed Objects",
    "footer.rights": "All rights reserved",
    "footer.links": "Links",
    "footer.connect": "Connect",
  }
};
